/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiPaymentsMutationRequest, PostApiPaymentsMutationResponse, PostApiPaymentsQueryParams, PostApiPayments400, PostApiPayments403, PostApiPayments404, PostApiPayments409, PostApiPayments500 } from "../entities/PostApiPayments";

function getPostApiPaymentsUrl() {
  const res = { method: 'POST', url: `/api/payments` as const }
  return res
}

/**
 * @description Создаёт платёж ЮKassa для группы записей и возвращает ссылку на оплату
 * @summary Создать платёж
 * {@link /api/payments}
 */
export async function postApiPayments(data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams, config: Partial<RequestConfig<PostApiPaymentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, PostApiPaymentsMutationRequest>({ method : "POST", url : getPostApiPaymentsUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}